var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.6875C12.4942 6.6875 13.8142 7.045 14.8867 7.5125C15.8767 7.9525 16.5 8.9425 16.5 10.015V11.5H5.5V10.0242C5.5 8.9425 6.12333 7.9525 7.11333 7.52167C8.18583 7.045 9.50583 6.6875 11 6.6875ZM3.66667 6.91667C4.675 6.91667 5.5 6.09167 5.5 5.08333C5.5 4.075 4.675 3.25 3.66667 3.25C2.65833 3.25 1.83333 4.075 1.83333 5.08333C1.83333 6.09167 2.65833 6.91667 3.66667 6.91667ZM4.7025 7.925C4.36333 7.87 4.02417 7.83333 3.66667 7.83333C2.75917 7.83333 1.8975 8.02583 1.11833 8.365C0.44 8.65833 0 9.31833 0 10.0608V11.5H4.125V10.0242C4.125 9.26333 4.33583 8.54833 4.7025 7.925ZM18.3333 6.91667C19.3417 6.91667 20.1667 6.09167 20.1667 5.08333C20.1667 4.075 19.3417 3.25 18.3333 3.25C17.325 3.25 16.5 4.075 16.5 5.08333C16.5 6.09167 17.325 6.91667 18.3333 6.91667ZM22 10.0608C22 9.31833 21.56 8.65833 20.8817 8.365C20.1025 8.02583 19.2408 7.83333 18.3333 7.83333C17.9758 7.83333 17.6367 7.87 17.2975 7.925C17.6642 8.54833 17.875 9.26333 17.875 10.0242V11.5H22V10.0608ZM11 0.5C12.5217 0.5 13.75 1.72833 13.75 3.25C13.75 4.77167 12.5217 6 11 6C9.47833 6 8.25 4.77167 8.25 3.25C8.25 1.72833 9.47833 0.5 11 0.5Z",
    fill: "#7E0386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamicon);
export default __webpack_public_path__ + "static/media/teamicon.c268a695cc29e270731de4e75522343c.svg";
export { ForwardRef as ReactComponent };